import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        config:{
            date:{
                thisDay:{},thisMonth:{},thisYears:{},
                lastDay:{},lastMonth:{},lastYears:{},
            },
            page:{
                hadChild:0,
                activePage:''
            }
        },
        stations:{
            area:[],
            location:[],
            ownership:[],
            list:[],
            listCopy:[],
            sales:[],
            product:[],
          },
        payment:{
            general:{
                thisDay:[],thisWeek:[],thisMonth:[],thisYears:[],InputDate:[],
                lastDay:[],lastWeek:[],lastMonth:[],lastYears:[],lastInputDate:[]
            },
            detail:{
                thisDay:[],thisWeek:[],thisMonth:[],thisYears:[],InputDate:[],
                lastDay:[],lastWeek:[],lastMonth:[],lastYears:[],lastInputDate:[]
            },
            home:{}
        },
        search:{
            fuel:null
        },
        PetaWilayah:{
            province:null,
            kotakabupaten:null
        },
        username:null, page:'',
		logininfo: { loggedin:false , username:null }
    },

    mutations:{
        updateLoginInfo:(state,payload)=>{
            state.logininfo=payload
        },
        updateUsername:(state,payload)=>{
            state.username=payload
        },

        updatePageHadChild:(state,payload)=>{
            state.config.page.hadChild=payload
        },
        updatePageActive:(state,payload)=>{
            state.config.page.activePage=payload
        },
        updateStationList:(state,payload)=>{      
            state.stations.list=payload
        },
        updatePaymentThisWeek:(state,payload)=>{
            state.payment.general.thisWeek=payload
        },
        updatePaymentHome:(state,payload)=>{
            state.payment.home=payload
        },
        updateSearchFuel:(state,payload)=>{
            state.search.fuel=payload
        },
        updatePetaWilayahProvince:(state,payload)=>{
            state.PetaWilayah.province=payload
        },
        updatePetaWilayahKotaKabupaten:(state,payload)=>{
            state.PetaWilayah.kotakabupaten=payload
        },

    },
    getters:{
        getLoginInfo:(state)=>{
            return state.logininfo
        },
        getUsername:(state)=>{
            return state.username
        },

        pageActive:(state)=>{
            return state.config.page.activePage;
        },
        pageHadChild:(state)=>{
            return state.config.page.hadChild
        },
        getStationList:(state)=>{
            return state.stations.list
        },
        getPaymentHome:(state)=>{
            return state.payment.home
        },
        getSearchFuel:(state)=>{
            return state.search.fuel
        },
        getPetaWilayahProvince:(state)=>{
            return state.PetaWilayah.province
        },
        getPetaWilayahKotaKabupaten:(state)=>{
            return state.PetaWilayah.kotakabupaten
        },        

    },
})